import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, InputText, Toast } from "primereact";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";

import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../Base/Services/ToastService";
import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";

import { getPosiciones } from "../../../../API/RRHH/Posiciones/PosicionesRequest";
import { EditarVacante, GuardarVacante } from "../../../../API/RRHH/Vacantes/VacantesRequests";
import DetallesVacantesCRUD from "./DetallesVacantesCRUD";


const VacantesCRUD = ({ showDialog, setShowDialog, getInfo, selected, setSelected, modo }) => {
  const toast = useRef(null);

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [posiciones, setPosiciones] = useState([]);  
  const [showDialogDetalles, setShowDialogDetalles] = useState(false);
  
  const initialValues = {
    IdVacante: -1,
    Reemplazo: false,
    Sustitucion: false,
    NuevaPlaza: false,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const posicionesTempo = await getPosiciones()
    setPosiciones(posicionesTempo.filter(p => p.IdStatus === 5))

    if(selected[0]?.IdVacante > 0){
        setValues({
            ...selected[0],
            Experiencia: selected[0]?.Conocimiento,
        });
    }else{
        setValues(initialValues);
    }

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    getInfo()
    setSelected([])
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Posicion?.IdPosicion && !values?.IdPosicion) {
        error.IdPosicion = true;
        error.error = true;
    }
    if (!values.Area) {
      error.Area = true;
      error.error = true;
    }
    if (!values.TipoTrabajo) {
        error.TipoTrabajo = true;
        error.error = true;
    }
    if (!values.NoPlazas) {
        error.NoPlazas = true;
        error.error = true;
    }
    if (!values.Objetivo) {
        error.Objetivo = true;
        error.error = true;
    }
    if (!values.Experiencia) {
        error.Experiencia = true;
        error.error = true;
    }
    if (!values.Educacion) {
        error.Educacion = true;
        error.error = true;
    }
    if (!values.Educacion) {
        error.Educacion = true;
        error.error = true;
    }
    if (!values.ComentarioPerfil) {
        error.ComentarioPerfil = true;
        error.error = true;
    }
    if (!values.CriteriosContratacion) {
        error.CriteriosContratacion = true;
        error.error = true;
    }
    if(values?.Reemplazo === false && values?.Sustitucion === false && values?.NuevaPlaza === false){
        error.Reemplazo = true;
        error.Sustitucion = true;
        error.NuevaPlaza = true;
        error.error = true;
    }


    setError(error);
    return error;
  };

  const agregarVacante = async () => {
    const e = verificarInfo();

    if (!e.error) {

      const Datos = {
        IdVacante: selected[0]?.IdVacante ? selected[0]?.IdVacante : -10,
        IdPosicion: values?.Posicion?.IdPosicion || values?.IdPosicion,
        NoPlazas: values?.NoPlazas,
        Objetivo: values?.Objetivo,
        ComentarioPerfil: values?.ComentarioPerfil,
        CriteriosContratacion: values?.CriteriosContratacion,
        Reemplazo: values?.Reemplazo,
        Sustitucion: values?.Sustitucion,
        NuevaPlaza: values?.NuevaPlaza,
        EnPresupuesto: values?.EnPresupuesto,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      };

      if(Datos.IdVacante > 0){
        setLoading(true)
        const resultado = await EditarVacante(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow(toast,"success","Datos Editados",resultado[0]?.MENSAJE );
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }else{
        const resultado = await GuardarVacante(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow( toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const asignarInformacion = () => {
    setValues({
        ...values,
        Area: values?.Posicion?.Area,
        TipoTrabajo: values?.Posicion?.TipoTrabajo,
        Experiencia: values?.Posicion?.Conocimiento,
        Educacion: values?.Posicion?.Educacion,
    })
  }

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Editar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {agregarVacante();}}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  
  useEffect(() => {
    asignarInformacion()
  }, [values?.Posicion?.IdPosicion]);

  const dialogTitle = modo === "Crear" ? "Agregar Vacante" : "Editar Vacante";

  return (
    <div>
      <Dialog
        visible={showDialog}
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: "50%" }}
      >
        <Toast ref={toast} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
            <div>
                <div className="d-flex mx-4">
                    <div className="field col-6 me-2 mt-2">
                        <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Posicion"}
                                value={values.Posicion}
                                items={posiciones}
                                field={"Posicion"}
                                label={"Título del puesto"}
                                handleInputChange={handleInputChange}
                                className={error.IdPosicion ? "p-invalid" : ""}
                            />
                        </span>
                    </div>

                    <div className="field col-6 me-2  mt-2">
                        <span className="p-float-label">
                            <InputText
                                name="Area"
                                value={values.Area}
                                disabled
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Area ? "p-invalid" : ""}
                            />
                            <label htmlFor="Area">Area</label>
                        </span>
                    </div>
                </div>

                <div className="d-flex mx-4 mt-2">
                    <div className="field col-6 me-2  mt-2">
                        <span className="p-float-label">
                            <InputText
                                name="TipoTrabajo"
                                value={values.TipoTrabajo}
                                onChange={handleInputChange}
                                disabled
                                style={{ width: "100%" }}
                                className={error.TipoTrabajo ? "p-invalid" : ""}
                            />
                            <label htmlFor="TipoTrabajo">Departamento</label>
                        </span>
                    </div>
                    <div className="field col-6 me-2  mt-2">
                        <span className="p-float-label">
                            <InputNumber
                                name="NoPlazas"
                                value={values.NoPlazas}
                                onChange={handleInputChange}
                                minFractionDigits={0}    
                                maxFractionDigits={0}   
                                style={{ width: "100%" }}
                                className={error.NoPlazas ? "p-invalid" : ""}
                            />
                            <label htmlFor="Area">Numero de Plazas</label>
                        </span>
                    </div>
                </div>

                <div className="d-flex mx-4 mt-2">
                    <div className="field col-12 mt-2">
                        <span className="p-float-label">
                            <InputText
                                name="Objetivo"
                                value={values.Objetivo}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Objetivo ? "p-invalid" : ""}
                            />
                            <label htmlFor="Objetivo">Objetivo de Contratación</label>
                        </span>
                    </div>
                </div>

                <div className="d-flex mx-4 mt-2">
                    <div className="field col-12 me-2  mt-2">
                        <span className="p-float-label">
                            <InputText
                                name="Experiencia"
                                value={values.Experiencia}
                                onChange={handleInputChange}
                                disabled
                                style={{ width: "100%" }}
                                className={error.Experiencia ? "p-invalid" : ""}
                            />
                            <label htmlFor="Experiencia">Experiencia</label>
                        </span>
                    </div>
                </div>

                <div className="d-flex mx-4 mt-2">
                    <div className="field col-12 me-2  mt-2">
                        <span className="p-float-label">
                            <InputText
                                name="Educacion"
                                value={values.Educacion}
                                onChange={handleInputChange}
                                disabled
                                style={{ width: "100%" }}
                                className={error.Educacion ? "p-invalid" : ""}
                            />
                            <label htmlFor="Educacion">Educación</label>
                        </span>
                    </div>
                </div>

                <div className="d-flex mx-4 mt-2">
                    <div className="field col-12 mt-2">
                        <span className="p-float-label">
                            <InputText
                                name="ComentarioPerfil"
                                value={values.ComentarioPerfil}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.ComentarioPerfil ? "p-invalid" : ""}
                            />
                            <label htmlFor="ComentarioPerfil">Otros</label>
                        </span>
                    </div>
                </div>

                <div className="d-flex mx-4 mt-2">
                    <div className="field col-12 mt-2">
                        <span className="p-float-label">
                            <InputText
                                name="CriteriosContratacion"
                                value={values.CriteriosContratacion}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.CriteriosContratacion ? "p-invalid" : ""}
                            />
                            <label htmlFor="CriteriosContratacion">Criterios de Contratación</label>
                        </span>
                    </div>
                </div>

                <div className="d-flex mx-4 mt-2">
                    <div className="field col-6 mt-2 d-flex gap-3">
                        <span className="p-float-label mt-2">
                            <span className="mx-2 mt-2">Reemplazo</span>
                            <Checkbox
                                id="Reemplazo"
                                name="Reemplazo"
                                checked={values.Reemplazo}
                                className={error.Reemplazo ? "p-invalid" : ""}
                                onChange={(e) => {
                                    setValues({
                                        ...values,
                                        Reemplazo: e.checked,
                                        Sustitucion: e.checked ? false : values.Sustitucion,
                                        NuevaPlaza: e.checked ? false : values.NuevaPlaza,
                                    })
                                }}
                            />
                        </span>
                        <span className="p-float-label mt-2">
                            <span className="mx-2 mt-2">Sustitución</span>
                            <Checkbox
                                id="Sustitucion"
                                name="Sustitucion"
                                checked={values.Sustitucion}
                                className={error.Sustitucion ? "p-invalid" : ""}
                                onChange={(e) =>{
                                    setValues({
                                        ...values,
                                        Sustitucion: e.checked,
                                        Reemplazo: e.checked ? false : values.Reemplazo,
                                        NuevaPlaza: e.checked ? false : values.NuevaPlaza,
                                    })
                                }}
                            />
                        </span>
                        <span className="p-float-label mt-2">
                            <span className="mx-2 mt-2">Nueva Plaza</span>
                            <Checkbox
                                id="NuevaPlaza"
                                name="NuevaPlaza"
                                checked={values.NuevaPlaza}
                                className={error.NuevaPlaza ? "p-invalid" : ""}
                                onChange={(e)=>{
                                    setValues({
                                        ...values,
                                        NuevaPlaza: e.checked,
                                        Reemplazo: e.checked ? false : values.Reemplazo,
                                        Sustitucion: e.checked ? false : values.Sustitucion,
                                    })
                                }}
                            />
                        </span>
                    </div>
                    <div className="field col-6 mt-2">
                        <span className="p-float-label mt-2">
                            <span className="mx-2 mt-2">En Presupuesto</span>
                            <Checkbox
                                id="EnPresupuesto"
                                name="EnPresupuesto"
                                checked={values.EnPresupuesto}
                                onChange={handleInputChange}
                            />
                        </span>
                    </div>
                </div>

                {values?.IdVacante > 0 &&(
                    <div className="flex-end mx-4">
                        <Button
                            label="Agregar Detalles"
                            icon="pi pi-plus"
                            onClick={() => setShowDialogDetalles(true)}
                        />
                    </div>
                )}
            </div>
        </div>
      </Dialog>

      <div>
        {showDialogDetalles && (
            <DetallesVacantesCRUD
            showDialogDetalles={showDialogDetalles}
            setShowDialogDetalles={setShowDialogDetalles}
            getInfo={()=>{}}
            selected={[values]}
            setSelected={()=>{}}
            />
        )}
      </div>


    </div>
  );
};

export default VacantesCRUD;
